import 'react-toastify/dist/ReactToastify.css';
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";

import {
  doCreateBooking,
  doCreateService,
  doCreateServiceCustomForm,
  doCreateServiceType,
  doDeleteService,
  doDeleteServiceCustomForm,
  doGetBooking,
  doGetService,
  doListBookings,
  doListServiceCustomForms,
  doListServices,
  doListServiceType,
  doUpdateBooking,
  doUpdateService,
  doUpdateServiceType,
  doUpdateServiceCustomForm,
  doDeleteServiceType
} from "../../services/booking.service";

export const onGetServiceList = createAsyncThunk("bookings/getServiceList", async () => {
  try {
    const response: any = await doListServices(0);
    return response;
  } catch (error) {
    return error;
  }
});

export const onGetServiceDetail = createAsyncThunk("bookings/getServiceDetail", async (serviceId: string) => {
  try {
    const response: any = await doGetService(serviceId);
    return response;
  } catch (error) {
    return error;
  }
});

export const onAddService = createAsyncThunk("bookings/addService", async (params: any) => {
  try {
    const response = doCreateService(params);
    const data = await response;
    toast.success("Service Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Service Added Failed", { autoClose: 2000 });
    return error;
  }
});

export const onUpdateService = createAsyncThunk("bookings/updateService", async (params: any) => {
  try {
    const response = doUpdateService(params);
    const data = await response;
    toast.success("Service updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Service updated Failed", { autoClose: 2000 });
    return error;
  }
});

export const onDeleteService = createAsyncThunk("bookings/deleteService", async (serviceId: string) => {
  try {
    const response = doDeleteService(serviceId);
    toast.success("Service deleted Successfully", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error("Service deleted Failed", { autoClose: 2000 });
    return error;
  }
});

export const onGetBookingList = createAsyncThunk("bookings/getBookingList", async () => {
  try {
    const response: any = await doListBookings(0);
    return response;
  } catch (error) {
    return error;
  }
});

export const onGetBookingDetail = createAsyncThunk("bookings/getBookingDetail", async (serviceId: string) => {
  try {
    const response: any = await doGetBooking(serviceId);
    return response;
  } catch (error) {
    return error;
  }
});

export const onAddBooking = createAsyncThunk("bookings/addBooking", async (params: any) => {
  try {
    const response = doCreateBooking(params);
    const data = await response;
    toast.success("Booking Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Booking Added Failed", { autoClose: 2000 });
    return error;
  }
});

export const onUpdateBooking = createAsyncThunk("bookings/updateBooking", async (params: any) => {
  try {
    const response = doUpdateBooking(params);
    const data = await response;
    toast.success("Booking updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Booking updated Failed", { autoClose: 2000 });
    return error;
  }
});

export const onGetServiceCustomFormList = createAsyncThunk("bookings/getServiceCustomFormList", async () => {
  try {
    const response: any = await doListServiceCustomForms(0);
    return response;
  } catch (error) {
    return error;
  }
})

export const onAddServiceCustomForm = createAsyncThunk("bookings/addServiceCustomForm", async (params: any) => {
  try {
    const response = doCreateServiceCustomForm(params);
    const data = await response;
    toast.success("Form Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Form Added Failed", { autoClose: 2000 });
    return error;
  }
});

export const onUpdateServiceCustomForm = createAsyncThunk("bookings/updateServiceCustomForm", async (params: any) => {
  try {
    const response = doUpdateServiceCustomForm(params);
    const data = await response;
    toast.success("Form updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Form updated Failed", { autoClose: 2000 });
    return error;
  }
});

export const onDeleteServiceCustomForm = createAsyncThunk("bookings/deleteServiceCustomForm", async (serviceCustomFormId: string) => {
  try {
    const response = doDeleteServiceCustomForm(serviceCustomFormId);
    toast.success("Form deleted Successfully", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error("Form deleted Failed", { autoClose: 2000 });
    return error;
  }
})

export const onGetServiceTypeList = createAsyncThunk("bookings/getServiceTypeList", async () => {
  try {
    const response: any = await doListServiceType()
    return response
  } catch (error) {
    return error;
  }
})

export const onAddServiceType = createAsyncThunk("bookings/addServiceType", async (params: any) => {
  try {
    const response = doCreateServiceType(params);
    const data = await response;
    toast.success("Service Type Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Service Category Added Failed", { autoClose: 2000 });
    return error;
  }
})

export const onUpdateServiceType = createAsyncThunk("bookings/updateServiceType", async (params: any) => {
  try {
    const response = doUpdateServiceType(params);
    const data = await response;
    toast.success("Service Type Updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Service Category Updated Failed", { autoClose: 2000 });
    return error;
  }
})

export const onDeleteServiceType = createAsyncThunk("bookings/deleteServiceType", async (serviceTypeId: string) => {
  try {
    const response = await doDeleteServiceType(serviceTypeId);
    toast.success("Service Type Deleted Successfully", { autoClose: 2000 });
    return response;
  } catch (error: any) {
    if (error.includes('403')) {
      toast.error("There are services associated with this service type", { autoClose: 2000 });
    } else {
      toast.error("Service Type Deleted Failed", { autoClose: 2000 });
    }
    return error;
  }
})
